import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsTableColsSelectGebaeudeList extends GlobalConstantsTableCols {


  public static getColumns(): string[] {
    return [
      this.ANZEIGEN,
      this.BEZEICHNUNG,
      this.GALERIE,
      this.PLAENE,      
    ];
  }
}